import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-dlg-immo-steuer',
  templateUrl: './dlg-immo-steuer.component.html',
  styleUrls: ['./dlg-immo-steuer.component.css']
})
export class DlgImmoSteuerComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DlgImmoSteuerComponent>) { }

  ngOnInit() {
  }

  closeDlg(): void {
    this.dialogRef.close();
  }

}
